import type { TeamCard } from './types';

export const AREA_MOCK_RATIOS = [0.82, 0.75, 0.66, 0.58, 0.47, 0.28, 0.17] as const;
export const LENGTH_MOCK_RATIOS = [1.9, 1.75, 1.62, 1.55, 1.45, 1.32, 1.3] as const;

export const TEAM_STATUSES: TeamCard['status'][] = ['稳定', '巡查中', '保障中'];

export const DEFAULT_WORKLOG = '巡查计划、补植与更新、环境卫生管理';
export const DEFAULT_REGION_NAME = '区域八';
export const DEFAULT_SURVEY_DATE = '2025-12-05';
export const DEFAULT_MAINTENANCE_UNIT = '上海申迪园林投资建设有限公司';
export const DEFAULT_TEAM_INFO = '班组信息待补充';
export const DEFAULT_LEADER = '负责人待补充';

export const DEFAULT_MAP_BOUNDS: [[number, number], [number, number]] = [
  [30.87, 121.81],
  [30.91, 121.89],
];

export const DEFAULT_MAP_CENTER: [number, number] = [30.889, 121.846];
